import { Component, type ReactNode } from 'react';
import { ChunkImportError } from '../lib/lazyWithReload';
import Button from './Button';

export function RouteReloadFallback() {
  return (
    <main className="bk-card mx-auto my-8 max-w-md p-6 space-y-4" role="alert">
      <p className="text-fg">A new version of this page is available.</p>
      <Button type="button" onClick={() => window.location.reload()}>Reload</Button>
    </main>
  );
}

export default class LazyRouteBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(error: unknown) {
    // Render errors are separate from deployment recovery.
    if (!(error instanceof ChunkImportError)) throw error;
    return { failed: true };
  }

  render() {
    return this.state.failed ? <RouteReloadFallback /> : this.props.children;
  }
}
